import {
  Box, Typography, Chip, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, alpha, useTheme,
} from '@mui/material';

const SIG_COLORS = {
  signed: { color: '#4caf50' },
  pending: { color: '#ff9800' },
  refused: { color: '#f44336' },
  expired: { color: '#607d8b' },
  cancelled: { color: '#9e9e9e' },
  vide: { color: '#bdbdbd' },
};

const UserSignaturesTab = ({ signatures }) => {
  const theme = useTheme();

  if (!signatures?.length) {
    return <Typography variant="body2" sx={{ color: theme.palette.text.secondary, py: 3 }}>No signatures found.</Typography>;
  }

  return (
    <TableContainer sx={{ borderRadius: '8px', border: `1px solid ${theme.palette.divider}` }}>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ bgcolor: theme.palette.action.hover }}>
            <TableCell sx={{ fontWeight: 600 }}>Contract</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Signed At</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Created</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {signatures.map((s, i) => {
            const sc = SIG_COLORS[s.status] || { color: '#607d8b' };
            return (
              <TableRow key={s.id || i}>
                <TableCell>
                  <Typography variant="body2" sx={{ fontWeight: 500, maxWidth: 300 }} noWrap>
                    {s.contract_title || 'Untitled'}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Chip
                    label={s.status}
                    size="small"
                    sx={{ fontWeight: 600, fontSize: '0.7rem', bgcolor: alpha(sc.color, 0.12), color: sc.color, textTransform: 'capitalize' }}
                  />
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {s.signed_at ? new Date(s.signed_at).toLocaleString() : '—'}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {s.created_at ? new Date(s.created_at).toLocaleDateString() : '—'}
                  </Typography>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default UserSignaturesTab;
